module.exports = __webpack_public_path__ + "img/result_txt_yg.fcccc9af.png";